const sleep = msec =>
  new Promise(resolve => setTimeout(resolve, msec))

const searchShippingDayElement = async () => {
  for (let i = 0; i < 40; i++) {
    const element1 = document.querySelector('.cart__delivery-date')
    const element2 = document.querySelector('.cart__delivery-date-notes')
    const element3 = document.querySelector('.cart__vip')
    const element4 = document.querySelector('.cart__delivary-time')
    
    // 両方の要素が見つかった場合は配列として返す
    if (element1 || element2 || element3 || element4) {
      const results = []
      if (element1) results.push(element1)
      if (element2) results.push(element2)
      if (element3) results.push(element3)
      if (element3) results.push(element4)
      return results
    }
    
    await sleep(200)
  }
  return null
}

let shippingDayElements = []
searchShippingDayElement().then(elements => {
  if (elements) {
    shippingDayElements = elements
  }
})

const searchGiftOptionElement = async () => {
   for (let i = 0; i < 40; i++) {
      const giftOptionElement = document.querySelectorAll('.anygift-option-button__circle')[1]
      if (giftOptionElement) {
          return giftOptionElement
      }
      await sleep(200)
  }
  return null
}

searchGiftOptionElement().then((giftOptionElement) => {
  if (giftOptionElement) {
    const giftOptionObserver = new MutationObserver((mutations) => {
      mutations.forEach((value) => {
        const isGiftSelected = Array.from(value.target.classList).includes('anygift-option-button__circle-active')
        if (isGiftSelected) {
          // 全ての配送日表示要素を非表示にする
          shippingDayElements.forEach(element => {
            element.style.display = 'none'
          })
        } else {
          // 全ての配送日表示要素を表示する
          shippingDayElements.forEach(element => {
            element.style.display = 'block'
          })
        }
      });
    });
    const observerConfig = {
      childList: false,
      attributes: true,
      characterData: false,
      subtree: false,
    };
    giftOptionObserver.observe(giftOptionElement, observerConfig)
  }
})

fetch('/cart.js').then(
  async cart => {
    const res = await cart.json()
    const isGiftEnabledItemInCart = res.items.some(item =>
      item.properties &&
        'ギフト購入' in item.properties &&
        item.properties['ギフト購入'] === '有効',
    )
    if (isGiftEnabledItemInCart) {
      // 全ての配送日表示要素を非表示にする
      if (shippingDayElements.length > 0) {
        shippingDayElements.forEach(element => {
          element.style.display = 'none'
        })
      }
    }                                        
  },
  error => {
    console.log(`cart.js 読み込み失敗 ${error.message}`);
  }
);